const api_prod = 'https://api.trocaturno.com.br/';
const api_dev = 'http://localhost:9290/';

export const environment = {
  production: false,
  api: api_prod,
  proxy: '/proxy/service/',
  version: 'Versão 2.1.23 - 04/05/2026'
};
